import { useNavigate } from 'react-router';
import { FundSummary } from '@/types/fund';
import { usePrefetchFund } from '@/hooks/react-query/usePrefetch';
import {
  getFundStatusAppearance,
  getFundTypeDisplayName,
  getFundStatusDisplayName,
} from '@/services/funds/displayService';
import { formatCurrencyNoDecimals } from '@/utils/formatters';

interface ChildFundRowProps {
  childFund: FundSummary;
  commitmentAmount: number;
}

export function ChildFundRow({
  childFund,
  commitmentAmount,
}: ChildFundRowProps) {
  const navigate = useNavigate();
  const prefetchFund = usePrefetchFund();

  return (
    <tr
      className="bg-muted/50 hover:bg-accent cursor-pointer"
      onClick={() => navigate(`/app/funds/${childFund.id}`)}
      onMouseEnter={() => prefetchFund(childFund.id)}
    >
      <td className="px-6 py-2 whitespace-nowrap">
        <div className="flex items-center">
          <div className="w-6" data-testid="hierarchy-spacer" />
          <div
            className="w-4 h-px bg-muted-foreground mr-2"
            data-testid="hierarchy-indicator"
          />
          <div className="text-sm text-foreground">
            {childFund.display_name || childFund.name}
          </div>
        </div>
      </td>
      <td className="px-6 py-2 whitespace-nowrap">
        <span className="text-sm text-muted-foreground">
          {getFundTypeDisplayName(childFund.fund_type)}
        </span>
      </td>
      <td className="px-6 py-2 whitespace-nowrap">
        <span
          className={`inline-flex px-2 py-1 text-xs font-medium rounded-full ${getFundStatusAppearance(childFund.status)}`}
        >
          {getFundStatusDisplayName(childFund.status)}
        </span>
      </td>
      <td className="px-6 py-2 whitespace-nowrap text-sm text-muted-foreground">
        {childFund.vintage_year}
      </td>
      <td className="px-6 py-2 whitespace-nowrap text-sm text-muted-foreground">
        {childFund.base_currency}
      </td>
      <td className="px-6 py-2 whitespace-nowrap text-right">
        <div className="text-sm text-foreground">
          {formatCurrencyNoDecimals(commitmentAmount, childFund.base_currency)}
        </div>
      </td>
    </tr>
  );
}
